import React from "react";
import { Tooltip,Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { StarFilled, DollarOutlined, LikeFilled } from "@ant-design/icons";
import "./UiRecommendationHeader.css";

const { Title, Text } = Typography;

const ICONS_MAP = {
  star: StarFilled,
  dollar: DollarOutlined,
  thumbsUp: LikeFilled,
};

const UIRecommendationHeaderNew = React.memo(
  ({ title, subtitle, iconType, backgroundColor = "transparent", fontColor = "#000000" }) => {
    const IconComponent = ICONS_MAP[iconType];

    return (
      <div
      className="ui-recommendation-header"
      style={{ backgroundColor, display: "flex", alignItems: "center" }}
    >
      {IconComponent && (
        <div style={{ marginRight: "0.8rem" }}>
          <IconComponent className="headerIcon" style={{ color: fontColor }} />
        </div>
      )}

      <div style={{ display: "flex", alignItems: "start", flexDirection: "column" }}>
        <Title level={5} className="title" style={{ color: fontColor, margin: 0, fontSize: "16px" }}>
          {title}
        </Title>

        {subtitle && (
          <Text type="secondary" style={{ fontSize: "12px", color: fontColor }}>
            {subtitle}
          </Text>
        )}
      </div>
    </div>
    );
  }
);

export default UIRecommendationHeaderNew;